import DataTable from 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.css';
import 'datatables.net-buttons-bs5';
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.css";
import 'datatables.net-rowgroup-bs5';
import 'datatables.net-rowgroup-bs5/css/rowGroup.bootstrap5.css';
import 'datatables.net-rowreorder-bs5';
import 'datatables.net-rowreorder-bs5/css/rowReorder.bootstrap5.css';
import 'datatables.net-scroller-bs5';
import 'datatables.net-scroller-bs5/css/scroller.bootstrap5.css';
import 'datatables.net-searchpanes-bs5';
import 'datatables.net-searchpanes-bs5/css/searchPanes.bootstrap5.css';
import 'datatables.net-select-bs5';
import 'datatables.net-select-bs5/css/select.bootstrap5.css';
import Editor from '@datatables.net/editor-bs5';

import Tagify from '@yaireo/tagify';
import "@yaireo/tagify/dist/tagify.css";
import * as tabler from '@tabler/core';
import "@tabler/core/dist/css/tabler.css";
import "@tabler/core/dist/css/tabler-vendors.css";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss';
import moment from 'moment';
import 'moment-timezone';

window.DataTable = DataTable;
window.Editor = Editor;
window.Tagify = Tagify;
window.tabler = tabler;
window.Swal = Swal;
window.moment = moment;
